// Minimal class-name joiner. We use the standard `clsx` pattern but avoid
// a dependency for two lines of code.

export function cn(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
